// @flow
import React, { Component } from "react";
import moment from "moment";
import _ from "lodash";
import I18n from "../../../i18n/I18n";
import Icon from "../../common/Icon";
import Button from "../../common/button/Button";
import Badge from "../../common/badge/Badge";
import OrderDetailsTable from "./orderDetailsTable/OrderDetailsTable";
import EmptyResults from "../../common/emptyResults/EmptyResults";
import styles from "./OrderDetails.scss";

class OrderDetails extends Component {
  state: {
    acceptedOffers: ?Array<Object>,
    modifiable: boolean
  };
  constructor(props: Object) {
    super(props);
    const acceptedOffers = props.data ? props.data.grouped_items : null;
    const acceptedFormat = [];
    if (acceptedOffers && acceptedOffers !== "undefined") {
      acceptedOffers.map((offer, index) => {
        const offerFormat = {
          id_offer: offer.idOffer,
          quantity: offer.accepted_quantity
        };
        acceptedFormat.push(offerFormat);
      });
    }
    this.state = {
      acceptedOffers: acceptedFormat.sort(),
      modifiable: false
    };
    this.acceptOrder = this.acceptOrder.bind(this);
    this.onQtyChange = this.onQtyChange.bind(this);
  }

  onQtyChange(offer) {
    const acceptedOffers = this.state.acceptedOffers;
    if (
      acceptedOffers &&
      typeof acceptedOffers !== "undefined" &&
      offer !== null &&
      !_.isEmpty(offer)
    ) {
      const match = acceptedOffers.find(
        offerIn => offerIn && offer.id_offer === offerIn.id_offer
      );
      if (match) {
        acceptedOffers.splice(acceptedOffers.indexOf(match), 1);
      }
      acceptedOffers.push(offer);
    }

    this.setState({ acceptedOffers: acceptedOffers });
  }

  acceptOrder(poNr) {
    const acceptedOffers = this.state.acceptedOffers;

    this.props.onAcceptOrder(poNr, acceptedOffers);
  }

  modifyOrder() {
    this.setState({
      modifiable: !this.state.modifiable
    });
  }

  render() {
    const data = this.props.data || "";

    if (!data || _.isEmpty(data)) {
      return (
        <div>
          <EmptyResults
            type="order"
            handleBtnClick={() => this.props.onBack()}
          />
        </div>
      );
    }

    const summaryList = (title, content) => {
      return (
        <div className={styles.summaryCard}>
          <div className={styles.summaryTitle}>{title}</div>
          <div className={styles.summaryContent}>{content}</div>
        </div>
      );
    };

    const total = data
      ? {
          currency: this.props.currencyCode,
          value: data.total
        }
      : {};

    return (
      <div className={styles.ctr}>
        <div className={`${styles.header} ${data.isNew ? styles.isNew : ""}`}>
          <div className={styles.orderNrWrapper}>
            <button onClick={() => this.props.onBack()}>
              <Icon
                name={this.props.lang === "ar" ? "fwd-arrow" : "back-arrow"}
                className={styles.backArrow}
              />
            </button>
            <div className={styles.orderNr}>
              <h6 className={styles.orderTitle}>
                {I18n.getText("order-details.order", {}, "Order")}
              </h6>
              <h6 className={styles.orderNumber}>{data.poNr || ""}</h6>
            </div>
          </div>
          {data && !data.isNew ? (
            <Button
              className={styles.printCtr}
              variant="transparent"
              onClick={() => this.props.printOrderDetails(data.poNr)}
            >
              <Icon name="print" className={styles.printIcon} />
              <div>{I18n.getText("order-details.print", {}, "Print")}</div>
            </Button>
          ) : (
            <div>
            {false && <div className={styles.btnWrapper}>
              <Button
                variant="transparent"
                onClick={() => this.modifyOrder()}
                className={styles.flexer}
              >
                <Icon
                  name={this.state.modifiable ? "close" : "edit"}
                  className={styles.icon}
                />
                <div>
                  {this.state.modifiable
                    ? I18n.getText("order-details.cancel", {}, "Cancel")
                    : I18n.getText(
                        "order-details.modify-order",
                        {},
                        "Modify Order"
                      )}
                </div>
              </Button>
              <Button
                className={`${styles.accept} ${styles.flexer}`}
                onClick={() => this.acceptOrder(data.poNr)}
              >
                <Icon name="checkmark" className={styles.icon} />
                <div>
                  {this.state.modifiable
                    ? I18n.getText("order-details.confirm", {}, "Confirm")
                    : I18n.getText(
                        "order-details.accept-order",
                        {},
                        "Accept Order"
                      )}
                </div>
              </Button>
            </div>}
            </div>
          )}
        </div>
        <div className={styles.summary}>
          {summaryList(
            I18n.getText("order-details.total", {}, "Total"),
            I18n.formatCurrency(total)
          )}
          {data.quantity
            ? summaryList(
                I18n.getText("order-details.no-of-items", {}, "No Of Items"),
                data.quantity
              )
            : ""}
          {data.createdAt
            ? summaryList(
                I18n.getText("order-details.order-date", {}, "Order Date"),
                moment(new Date(data.createdAt).toUTCString()).format(
                  "MMM D, h:mm a "
                )
              )
            : ""}
          {data.fulfillmentMethod || data.isFbn
            ? summaryList(
                I18n.getText(
                  "order-details.fulfilment",
                  {},
                  "Fulfilment Method"
                ),
                data.fulfillmentMethod === "Fulfilled by noon" || data.isFbn ? (
                  <Badge />
                ) : data.fulfillmentMethod === "Seller B2B" ? (
                  <Badge sellerB2B />
                ) : (
                  data.fulfillmentMethod
                )
              )
            : ""}
          {data.status
            ? summaryList(
                I18n.getText("order-details.order-status", {}, "Order Status"),
                <div
                  className={`${styles.status} ${
                    data.isNew ? styles.new : ""
                  } ${
                    styles[
                      data.status
                        .toLowerCase()
                        .split(" ")
                        .join("_")
                    ]
                  }`}
                >
                  {data.status}
                </div>
              )
            : ""}
        </div>
        <div>
          <OrderDetailsTable
            data={data}
            currencyCode={this.props.currencyCode}
            total={data.total}
            modifiable={this.state.modifiable}
            onQtyChange={this.onQtyChange}
            browser={this.props.browser}
          />
        </div>
      </div>
    );
  }
}

export default OrderDetails;



// WEBPACK FOOTER //
// ./src/components/orders/orderDetails/OrderDetails.js